import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {toggleFavourite} from '../../../general/actionCreators';

import LightBoxManager from '../../../general/components/LightBox/Manager';

import Dialog from './ResetFavourites/Dialog';

const FavouriteIcon = ({isFavourite, show, onClick, ...props}) => (
    <span className={classNames('icon-favourite', {none: isFavourite === false})} onClick={onClick}>
        {show && <Dialog {...props} headline={null} />}
    </span>
);

FavouriteIcon.defaultProps = {
    show: false,
};

const FavouriteIconWrapper = ({isAnonymous, ...props}) => {
    if (isAnonymous) {
        return (
            <LightBoxManager>
                <FavouriteIcon {...props} />
            </LightBoxManager>
        );
    }

    return <FavouriteIcon {...props} />;
};

const mapStateToProps = ({isAnonymous}) => ({isAnonymous});

const mapDispatchToProps = (dispatch, {id}) => ({
    onClick: () => dispatch(toggleFavourite(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteIconWrapper);
